import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { ACTION_RULES_URL } from './action-api-urls';
import { ShopActionRule } from './action-types';

export interface CreateActionRuleRequest {
  action_type_id?: string | null;
  platform?: string | null;
  name: string;
  conditions: {
    max_percentage_change?: number;
    max_absolute_change?: number;
    allowed_transitions?: string[];
    risk_level_max?: string;
  };
  max_daily_auto_approvals: number;
  is_active?: boolean;
}

export interface CreateActionRuleResponse {
  success: boolean;
  message: string | null;
  data: ShopActionRule | null;
}

export default async function create_action_rule_api_call(
  ruleData: CreateActionRuleRequest
): Promise<ShopActionRule | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: ACTION_RULES_URL(shopSlug),
      method: 'POST',
      body: JSON.stringify(ruleData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'CREATE_ACTION_RULE';
    const customMsg = 'Action rule created successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false
    );

    const response: CreateActionRuleResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during create action rule request');
    return null;
  }
}
